<template>

    <m-edit1/>

    <m-products-3 v-bind='{...{"perPage":12,"productCardName":"mProductCard200","cardCLass":"my-2","cardWrapperCLass":"col-lg-6 col-12 ","showCategoriesSlider":false,"singlePrice":false,"offerType":"number","offerStatus":false,"productBrandProp":false,"productSearchProp":true,"productQuantityProp":false,"productFeatureProp":true,"productFeaturePanelOpenCloseProp":false,"productCategoryProp":true,"productStoresProp":false,"productSortProp":true,"relatedCurrentCategory":true,"productPriceFilterProp":false,"showKeywords":false,"smCardName":"mProductCard200","skeleton":"mProductArchiveSkeleton1","dashboardProduct":false,"publishStatusFilter":false,"image":null,"alt":"","cardLink":true,"infinityLoading":true,"chooseCategoriesFromTop":false,"cardLinkTarget":"_self","productStoresDirectFilter":null,"orderFilterProp":["brand","category","feature","search","quantity","store","price"],"archiveFilterProp":false},...{}}' :style='""' class="my-4 " ></m-products-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mProducts3 from '@moeinmdn/miw-alpha-components/src/package/Product/Products/Products3/Products3';

export default {
    name: 'HomeView',
    components: {mEdit1, mProducts3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
